import React, { PropsWithChildren, useId } from 'react';
import { Box, Stack, Typography, styled } from '@mui/material';

export type ProfileSectionProps = PropsWithChildren<{
  title: string;
}>;

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
})) as typeof Typography;

export const ProfileSection: React.FC<ProfileSectionProps> = ({ title, children }) => {
  const titleId = useId();

  return (
    <Box component="section" className="profile-section" aria-labelledby={titleId}>
      <Title
        id={titleId}
        className="profile-section__title"
        variant="callout"
        component="h2"
        fontWeight="medium"
        color="grey.900"
      >
        {title}
      </Title>

      <Stack className="profile-section__content" spacing={1.5}>
        {children}
      </Stack>
    </Box>
  );
};
